import reducer from './reducer';
import saga from './saga';
import * as selectors from './selectors';
import {actionMeta} from './meta';
import localPersistence from './localPersistence';

export default {
  api: actionMeta.urlBuilders,
  actions: actionMeta.actionCreators,
  constants: actionMeta.identifiers,
  saga: saga,
  reducer: reducer,
  selectors: selectors,
  localPersistence: localPersistence
};



// WEBPACK FOOTER //
// ./src/storeState/auth/index.js